(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["drop-announcement"] && !Shopify.designMode) return;
  try {
    class DropAnnouncement extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.dropAt;
      const target = new Date(raw).getTime();

      // An unparseable date must not produce "NaN Tage" on a live shop.
      if (Number.isNaN(target)) return;

      this.countdown = this.querySelector('[data-role="countdown"]');
      this.hideAfterMs = (parseInt(this.dataset.hideAfterMinutes, 10) || 0) * 60000;
      this.target = target;

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.target - Date.now();

      // Past the drop plus its grace period the block disappears entirely
      // rather than lingering at zero.
      if (remaining < -this.hideAfterMs) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }

      this.hidden = false;

      if (remaining <= 0) {
        this.dataset.state = 'live';
        this.zeige(this.getAttribute('data-live-label') || 'Jetzt geöffnet', '', '');
        return;
      }

      this.dataset.state = 'upcoming';
      const s = Math.floor(remaining / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;

      const pad = (n) => String(n).padStart(2, '0');

      // Ab einer Woche Abstand wird das Datum genannt statt der Sekunden.
      //
      // Gemessen stand hier "28 Tage 05:45:36", und die Sekunden liefen
      // sichtbar runter. Über vier Wochen hinweg sagen sie nichts: Niemand
      // wartet sekundenweise auf einen Termin in einem Monat, und ein
      // Zähler, der so lange läuft, macht aus einer Vorfreude eine lange
      // Wartezeit. Ein Datum kann man sich dagegen vormerken.
      //
      // Unter einer Woche bleibt der Zähler, denn dort trägt er: Da wird aus
      // "irgendwann" ein "heute Abend".
      const zeigeDatum = d >= 7;
      if (zeigeDatum) {
        const datum = new Date(this.target).toLocaleDateString('de-DE', {
          day: 'numeric',
          month: 'long',
        });
        this.zeige(String(d), d === 1 ? 'Tag' : 'Tage', `öffnet am ${datum}`);
      } else if (d > 0) {
        this.zeige(String(d), d === 1 ? 'Tag' : 'Tage', `${pad(h)}:${pad(m)}:${pad(sec)} verbleiben`);
      } else {
        this.zeige(`${pad(h)}:${pad(m)}:${pad(sec)}`, '', 'bis zur Öffnung');
      }
    }

    /* Die Zahl gross, alles andere klein.
       --------------------------------------------------------------------
       Vorher stand hier eine einzige Zeile: „26 Tage · öffnet am
       5. September", komplett in derselben Groesse. Auf einer Seite, deren
       ganzer Zweck der Termin ist, war das die unauffaelligste Stelle —
       Dennis' Bild zeigt sie als schmale graue Zeile zwischen zwei leeren
       Flaechen.

       Eine Zahl, die man aus drei Metern Entfernung lesen kann, ist der
       Unterschied zwischen einer Notiz und einem Termin.

       Aufgebaut mit createElement statt innerHTML: Der Inhalt kommt zwar aus
       eigener Rechnung und nicht von aussen, aber ein Bauteil, das
       HTML-Strings zusammensetzt, wird irgendwann von jemandem mit einem
       Feldwert gefuettert. */
    zeige(gross, einheit, klein) {
      const cd = this.countdown;
      cd.textContent = '';

      const z = document.createElement('span');
      z.className = 'drop-announcement__zahl';
      z.textContent = gross;
      cd.appendChild(z);

      if (einheit) {
        const e = document.createElement('span');
        e.className = 'drop-announcement__einheit';
        e.textContent = einheit;
        cd.appendChild(e);
      }

      if (klein) {
        const k = document.createElement('span');
        k.className = 'drop-announcement__klein';
        k.textContent = klein;
        cd.appendChild(k);
      }
    }
  }

  if (!customElements.get('drop-announcement')) {
    customElements.define('drop-announcement', DropAnnouncement);
  }
  } catch(e) { console.error(e); }
})();

})();
